<template>
  <div class="page-config-index">
    <div class="fun-btn-box">
      <auth-button auth="page:config:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >新增</el-button>
      </auth-button>
    </div>
    <Table
      :pagination="false"
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #logo="{ row }">
        <img class="logo" :src="row.logo" alt="" srcset="">
      </template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #customName="{ row }">{{ row.customName?row.customName:'---' }}</template>
      <template #location="{ row }">{{ row.location?getLocationName(row.location):'---'}}</template>
      <template #systemDefault="{ row }">{{ row.systemDefault ? '系统创建' : '手动创建'}}</template>
      <template #enable="{ row }">{{ row.enable == 1 ? '显示' : '隐藏' }}</template>
      <template #type="{ row }">{{ onType(row) }}</template>
      <template #url="{ row }">{{ row.url ? row.url : '---' }}</template>
      <template #operation="{ scope }">
        <auth-button auth="page:config:update">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button >
        </auth-button>
        <auth-button v-if="!scope.row.systemDefault" auth="page:config:delete">
          <el-button type="text" class="error" @click="onDelete(scope.row)">删除</el-button >
        </auth-button>
      </template>
    </Table>
  </div>
</template>
<script>
import AuthButton from '@/components/AuthButton'
import UploadImg from '@/components/UploadImg/index'
import Dialog from '@/components/Dialog/index'
import { api_getPageConfigList, api_deleteConfig } from '@/api/pageConfig'
import tableList from '@/mixins/tableList';
import Table from "@/components/Table/index";
export default {
  name: "PCIndex3",
  mixins: [tableList],
  components: {
    AuthButton,
    Table,
    Dialog,
    UploadImg
  },
  data() {
    return {
      tableThData: [
        { prop: "logo", label: "图标", minWidth: "130", },
        { prop: "name", label: "默认名称", minWidth: "150", },
        { prop: "customName", label: "自定义名称", minWidth: "150", },
        { prop: "location", label: "页面", minWidth: "150", },
        { prop: "systemDefault", label: "配置类型", minWidth: "120", },
        { prop: "enable", label: "显示/隐藏", minWidth: "120", },
        { prop: "type", label: "跳转类型", minWidth: "100", },
        { prop: "url", label: "跳转链接", minWidth: "200", },
        { prop: "operation", label: "操作", minWidth: "160", },
      ]
    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
      }
      this.$router.push({query: params})
      const data = await api_getPageConfigList(params)
      console.log('data: ', data);
      this.tableTrData = data || []
      this.total = data.count
      this.loading = false
    },
    getLocationName (code) {
      switch (code) {
        case 'me':
          return '我的'
        case 'first':
          return '首页'
        case 'pay':
          return '付款页'
      }
    },
     // 跳转链接类型枚举
    onType(row) {
      if (row.type=='text') {
         return '富文本'
      } else if(row.type == 'out'){
         return '外部链接'
      }else if(row.type == 'base'){
         return '内部链接'
      }else{
        return '小程序跳转'
      }
    },

    // 删除
    onDelete(row) {
      this.$baseConfirm(
        '确认要删除图标？',
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
          await api_deleteConfig({id: row.id})
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
      )
    },

    // 创建
    onAdd() {
      this.$router.push({
        path: `/serverConfig/pageConfig/add`
      })
    },

    // 点击详情
    edit(row) {
      this.$router.push({
        path: `/serverConfig/pageConfig/add?id=${row.id}`
      })
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.page-config-index {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  .logo{
    width: 46px;
    height: 46px;
    border: 1px solid #979797;
    border-radius: 50%;
    overflow: hidden;
  }
  .fun-btn-box {
    margin-top: 20px;
  }
  .edit-dialog {
    padding-top: 20px;
    position: relative;
    .dialog-footer {
      text-align: right;
    }
    ::v-deep{
      .el-select{
        width: 100%;
      }
      .el-form-item{
        &.notes {
          margin-bottom: 32px;
          .el-form-item__content {
            &::before {
              position: absolute;
              left: 0;
              bottom: -22px;
              content: '( 填写“0”表示永久有效 )';
              width: 140px;
              height: 17px;
              line-height: 17px;
              font-size: 12px;
              color: #666666;
            }
            .el-form-item__error {
              height: 17px;
              left: 140px;
              padding-top: 7px;
            }
          }
        }
      }
    }
  }
}
</style>
